
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { getLongDate, getStringDate } from 'src/app/common/util';
import { ResponseObject } from 'src/app/models/response-object.model';
import { SaleResponse } from 'src/app/models/sale.model';
import { VendorResponse } from 'src/app/models/vendor.model';
import { SalesService } from 'src/app/services/sales.service';
import { VendorService } from 'src/app/services/vendor.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { InvoiceItemModel, InvoiceTemplateModel, ScenerySAT } from 'src/app/models/invoice-template.model';
import { TemplateInvoice } from 'src/app/templateInvoice/templateInvoice';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { InvoiceType } from 'src/app/enums/invoice-type.enum';
import { ProductService } from 'src/app/services/product.service';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { ActivatedRoute } from '@angular/router';
import { QueryParamsArService } from 'src/app/services/query-params-ar.service';
import { BillReceivableService } from 'src/app/services/bill-receivable.service';
import { forkJoin } from 'rxjs';
import { CompanyService } from 'src/app/services/company.service';

@Component({
  selector: 'app-history-sales',
  templateUrl: './history-sales.component.html',
  styleUrls: ['./history-sales.component.scss']
})
export class HistorySalesComponent implements OnInit {
  permissionType = PermissionTypeEnum;
  categorySelected = null;
  creating = false;
  editing = false;
  newSale: SaleResponse = new SaleResponse();
  sales: SaleResponse[] = [];
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  searchVendor = "";
  alwaysCreating = false;

  startDate = '';
  endDate = '';
  type = 0;
  invoiceCheck = true;
  receiptCheck = true;
  goodCheck = true;
  serviceCheck = true;
  isAscendent = 0;
  total = 0;
  loadingDownload: { [key: string]: boolean } = {};
  loadingPerfom: { [key: string]: boolean } = {};
  deleting: { [key: string]: boolean } = {};
  detailing: { [key: string]: boolean } = {};
  allowedWarehouses: { [key: number]: boolean } = {};
  invoiceDetail: any = null;
  invoiceNcreDetail: any = null;
  waitingFor = null;
  seeingAnulate = false;
  anulating = false;
  todayDate = new Date();
  cancelledDescription = "";
  userId = null;
  userEmail = '';
  seeingAll = false;
  companyName = "";
  currentCompany = null;
  filteredByWarehouse = false;
  warehouses = [];
  warehouseSelected = -1;

  transforming = false;
  productToTransform = null;
  timeout = null;
  filterProducts = [];
  products = [];
  productsIds: { [key: string]: any } = {}
  gettingProducts: { [key: string]: boolean } = {};
  seeingTransform: { [key: number]: boolean } = {};
  loadingData = false;
  ncreCheck = true;
  hasExtraTaxRegularConfig:boolean = false;

  inputs = {
    warehouse: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: 'fa-asterisk',
      color: 'danger',
      tooltip: 'status-warehouse',
      data: {
        id: null
      }
    },
    product: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: 'fa-asterisk',
      color: 'danger',
      tooltip: 'status-warehouse',
      data: {
        id: null
      }
    }
  };

  constructor(
    private vendorService: VendorService,
    private toastService: ToastrService,
    private saleService: SalesService,
    private authService: AuthenticationService,
    private createService: TemplateInvoice,
    private warehouseService: WarehouseService,
    private productService: ProductService,
    private route: ActivatedRoute,
    private queryParamsService: QueryParamsArService,
    private billReceivableService: BillReceivableService,
    private companyService: CompanyService,
  ) {
    const today = new Date();
    this.startDate = this.queryParamsService.getStringParam(this.route,"startDate", getStringDate(today));
    this.endDate = this.queryParamsService.getStringParam(this.route, "endDate", getStringDate(today));
    this.userId = JSON.parse(authService.getCurrentUser()).id;
    this.userEmail = JSON.parse(authService.getCurrentUser()).mail;
    
    var permissions = authService.getPermissions();
    var getUserPosition = authService.getUserPosition();
    if (permissions) {
      for (let i = 0; i < permissions.length; i++) {
        const element = permissions[i];
        if (element.roleId == 5033 && element.read) {
          this.seeingAll = true;
          break;
        } else if (element.roleId == 5034 && element.read) {
          this.filteredByWarehouse = true;
          break;
        }
      }
    }
    if (getUserPosition) {
      getUserPosition.forEach((u) => {
        if (u.warehouse != 0) {
          this.allowedWarehouses[u.warehouse] = true;
        }
      });
    }
    this.currentCompany = JSON.parse(authService.getCurrentCompany());
    this.companyName = this.currentCompany.companyName;
  }

  ngOnInit(): void {
    this.type = this.queryParamsService.getNumberParam(this.route, "type", 0);
    this.getWarehouses();
    this.getProducts();
    this.getConfigRegularExtraTax();
  }

  getConfigRegularExtraTax() {
    this.companyService.checkCompanyConfigRegularExtraTax().subscribe({
      next: (response: ResponseObject) => {
        this.hasExtraTaxRegularConfig = response.data;
      },
      error: (error: HttpErrorResponse) => {
        console.log("Error al traer la configuracion");
      }
    })
  }

  getProducts() {
    this.productService.getProductList().subscribe({
      next: (response: ResponseObject) => {
        this.productsIds = {}
        response.data.forEach(element => {
          this.productsIds[element.code] = element
        });
        this.products = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getWarehouses() {
    this.warehouseService.getWarehouseByClue("").subscribe(
      {
        next: (response: ResponseObject) => {
          this.warehouses = response.data;
          this.getSalesByIntervalDate();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      }
    );
  }

  /*
  getSalesByIntervalDate() {
    this.loadingData = true;
    this.saleService.getSalesByIntervalDate(getLongDate(this.startDate), getLongDate(this.endDate)).subscribe(
      {
        next: (response: ResponseObject) => {
          this.sales = response.data;
          if (!(this.userId == 3186)) {
            if (!this.seeingAll && !this.filteredByWarehouse) {
              this.sales = this.sales.filter((u) => {
                return u.user == this.userId
              })
            }
          }
          if (this.filteredByWarehouse && !this.seeingAll) {
            this.sales = this.sales.filter((s) => {
              return this.allowedWarehouses[s.warehouse];
            });
          }
          this.sales = this.sales.sort((a, b) => {
            if (b.date !== a.date) {
              return b.date - a.date;
            } else {
              return b.id - a.id;
            }
          });
          this.total = 0;
          this.sales.forEach((s) => {
            if (s.exchangeRate > 0) {
              this.total += ((s.totalCost * s.exchangeRate) + (s.totalTaxes * s.exchangeRate) + (s.totalExtraTax * s.exchangeRate));
            } else {
              this.total += (s.totalCost + s.totalTaxes + s.totalExtraTax);
            }
          });

          this.sales.forEach((s) => {
            this.getMethodPayment(s);
          });

          if (this.isAscendent == 1) {
            this.sales.reverse();
          }
          this.pagination.total = this.sales;
          this.filtering();
          this.loadingData = false;
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
          this.loadingData = false;
        }
      }
    );
  }
  */

  getSalesByIntervalDate() {
    this.loadingData = true;

    const start = getLongDate(this.startDate);
    const end = getLongDate(this.endDate);

    forkJoin({
      salesResponse: this.saleService.getSalesByIntervalDate(start, end),
      ncreResponse: this.billReceivableService.getNcreHistory(
        this.startDate,
        this.endDate
      )
    }).subscribe({
      next: ({ salesResponse, ncreResponse }: any) => {
        let normalSales: any[] = salesResponse.data ?? [];

        const erpDocuments: any[] = Array.isArray(ncreResponse)
          ? ncreResponse
          : ncreResponse.data ?? [];

        const ncres = erpDocuments.map(ncre =>
          this.convertNcreToSale(ncre)
        );


        normalSales = this.filterSalesByUserPermissions(normalSales);

        const filteredNcres = this.filterNcresByWarehousePermission(ncres);

        this.sales = normalSales.concat(filteredNcres);

        this.sales.sort((a, b) => {
          const dateA = new Date(a.date ?? a.accountingDate).getTime();
          const dateB = new Date(b.date ?? b.accountingDate).getTime();

          if (dateB !== dateA) {
            return dateB - dateA;
          }

          return String(b.id).localeCompare(String(a.id));
        });


        normalSales.forEach(sale => {
          this.getMethodPayment(sale);
        });

        if (Number(this.isAscendent) === 1) {
          this.sales.reverse();
        }

        this.pagination.total = this.sales;
        this.filtering();
        this.loadingData = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(
          error.error?.message ?? 'Error al obtener las ventas y notas de crédito'
        );
        this.loadingData = false;
      }
    });
  }

  getMethodPayment(invoice: any) {
    this.saleService.getMethodPaymentByInvoice(invoice.id).subscribe(
      {
        next: (response: ResponseObject) => {
          invoice.methodPay = response.data;
        },
        error: (error: HttpErrorResponse) => {
        }
      }
    );
  }

  resetNewFamily() {
    this.newSale = new SaleResponse();
  }

  editInvoice(invoice: any) {
    this.newSale = invoice;
    this.saleService.getDetailInvoice(invoice).subscribe({
      next: (response: ResponseObject) => {
        this.newSale['detail'] = response.data;
        var tempDate = new Date(this.newSale.date);
        this.newSale.date = getStringDate(tempDate);
        this.editing = true;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener el detalle de la factura");
      }
    })
  }

  resetDeletingDiv() {
    this.waitingFor = null;
  }

  changeType() {
    const today = new Date();
    switch (parseInt(this.type + "")) {
      case 0:
        {
          this.endDate = getStringDate(today);
          this.startDate = getStringDate(today);
          break;
        }
      case 1:
        {
          this.endDate = getStringDate(today);
          today.setDate(today.getDate() - 7)
          this.startDate = getStringDate(today);
          break;
        }
      case 2:
        {
          this.endDate = getStringDate(today);
          today.setDate(1)
          this.startDate = getStringDate(today);
          break;
        }
      case 3:
        {
          const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);

          this.startDate = getStringDate(firstDayLastMonth);
          this.endDate = getStringDate(lastDayLastMonth);
          break;
        }
      case 4:
        {
          this.endDate = getStringDate(today);
          today.setMonth(today.getMonth() - 2);
          this.startDate = getStringDate(today);
          break;
        }
      case 5:
        {
          this.endDate = getStringDate(today);
          today.setMonth(today.getMonth() - 3);
          this.startDate = getStringDate(today);
          break;
        }
    }
    this.queryParamsService.setParams(this.route, {
      type: this.type,
      startDate: this.startDate,
      endDate: this.endDate,
    });

    // this.getSalesByIntervalDate();
  }

  getFixedName(toFix: string) {
    var fixed = toFix;
    fixed = toFix.replace(/,+/g, ' ').replace(/\s+/g, ' ').trim();
    return fixed;
  }

  orderByDate(a: any, b: any) {
    return b.date - a.date;
  };

  changeOrder() {
    this.pagination.total.reverse();
    this.resetPagination();
  }
  changeDate() {
    if (this.startDate && this.endDate) {
      var tempStart = new Date(this.startDate);
      var tempEnd = new Date(this.endDate);
      if (tempStart > this.todayDate || tempEnd > this.todayDate) {
        this.toastService.info("No puedes ingresar fechas más allá del día de hoy");
      } else {
        if (tempStart > tempEnd) {
          this.toastService.info("La fecha de inicio debe ser más lejana que la de final");
        } else {
          this.queryParamsService.setParams(this.route , {
            type: this.type,
            startDate: this.startDate,
            endDate: this.endDate,
          });
          this.getSalesByIntervalDate();
        }
      }
    }
  }

  deleteInvoice(invoice: any) {
    this.waitingFor = invoice;
    this.seeingAnulate = false;
  }

  anulateInvoice(invoice: any) {
    this.waitingFor = invoice;
    this.seeingAnulate = true;
  }

  confirmDelete(invoice: any) {
    if (this.deleting[invoice.id]) {
      return;
    }
    this.deleting[invoice.id] = true;
    this.waitingFor = null;
    this.saleService.deleteInvoice(invoice).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Se ha eliminado la factura!");
        this.deleting = {}
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al eliminar");
        this.deleting = {}
      }
    });
  }

  confirmCanceledInvoice() {
    this.anulating = true;
    this.saleService.cancelInvoice(this.waitingFor, this.cancelledDescription).subscribe({
      next: (response: ResponseObject) => {
        this.seeingAnulate = false;
        this.toastService.success("Se ha completado la cancelación!");
        this.cancelledDescription = "";
        this.waitingFor.cancelled = true;
        this.waitingFor = null;
        this.anulating = false;
      },
      error: (error: any) => {

        this.seeingAnulate = false;
        // Para mostrar los mensajes del certificador
        if (error.error.data.description) {
          this.toastService.error(error.error.data.description);
        } else {
          this.toastService.error('Error al anular Factura');
        }
        this.waitingFor = null;
        this.anulating = false;
      }
    });
  }


  performConversion(invoice: any) {
    if (this.loadingPerfom[invoice.id]) {
      return;
    }
    this.loadingPerfom[invoice.id] = true;
    this.saleService.performConversion(invoice).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Se ha completado la conversion!");
        this.loadingPerfom[invoice.id] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al convertir");
        this.loadingPerfom[invoice.id] = false;
      }
    })
  }

  detailingInvoice(invoice: any) {
    if (this.detailing[invoice.id]) {
      return;
    }
    this.detailing[invoice.id] = true;
    this.getMoreProducts();
    this.saleService.getDetailInvoice(invoice).subscribe({
      next: (response: ResponseObject) => {
        this.invoiceDetail = invoice;
        this.invoiceDetail['detail'] = response.data;
        var tempDate = new Date(this.invoiceDetail.date);
        this.invoiceDetail['dateString'] = getStringDate(tempDate);
        this.detailing[invoice.id] = false;
        this.invoiceDetail['detail'].forEach((detail) => {
          detail['input'] = new InputAutocompleteModel("", false, true, "", "fa-asterisk", "", "", null, this.products);
        });
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener el detalle de la factura");
        this.detailing[invoice.id] = false;
      }
    })
  }

  detailingInvoiceNcree(invoice: any) {
    if (this.detailing[invoice.id]) {
      return;
    }
    this.detailing[invoice.id] = true;
    this.getMoreProducts();
    this.saleService.getDetailInvoice(invoice).subscribe({
      next: (response: ResponseObject) => {
        console.log(response);
        
        this.invoiceNcreDetail = invoice;
        this.invoiceNcreDetail['detail'] = response.data;
        var tempDate = new Date(this.invoiceNcreDetail.date);
        this.invoiceNcreDetail['dateString'] = getStringDate(tempDate);
        this.detailing[invoice.id] = false;
        this.invoiceNcreDetail['detail'].forEach((detail) => {
          detail['input'] = new InputAutocompleteModel("", false, true, "", "fa-asterisk", "", "", null, this.products);
        });
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener el detalle de la factura");
        this.detailing[invoice.id] = false;
      }
    })
  }

  async createInvoicePDF(invoiceData: any) {
    const selected = invoiceData.warehouseData;

    forkJoin({
      detailResponse: this.saleService.getDetailInvoice(invoiceData),
      taxRegimeResponse: this.saleService.getTaxRegimeCompany()
    }).subscribe({
      next: ({ detailResponse, taxRegimeResponse }: any) => {
        invoiceData.items = detailResponse.data ?? [];

        invoiceData.taxRegime =
          taxRegimeResponse?.data ?? taxRegimeResponse;

        const invoiceDataNew = this.getInvoiceData(invoiceData);

        invoiceDataNew['warehouse'] = selected;
        invoiceDataNew['id'] = invoiceData.id;

        if (selected['nfact'] <= 0 || selected['nfact'] > 5) {
          selected['nfact'] = 1;
          selected['fcolor'] = '#1D5073';
          selected['scolor'] = '#CCCCCC';
          selected['tcolor'] = '#E1E1E1';
          selected['slogan'] = '';
        }

        this.createService.isLoading = this.loadingDownload;

        const configurationInvoice = {
          id: selected['nfact'],
          fcolor: selected['fcolor'],
          scolor: selected['scolor'],
          tcolor: selected['tcolor'],
          slogan: selected['slogan']
        };

        if (selected['logo']) {
          this.createService.selectTemplate(
            configurationInvoice,
            invoiceDataNew,
            'https://s3.amazonaws.com/rrhh-images/warehouse/logos/' +
              selected['logo']
          );
          return;
        }

        if (
          this.currentCompany &&
          !this.currentCompany.companyLogo.includes(
            '/images/company-avatar2.png'
          )
        ) {
          this.createService.selectTemplate(
            configurationInvoice,
            invoiceDataNew,
            this.currentCompany.companyLogo
          );
        } else {
          this.createService.selectTemplate(
            configurationInvoice,
            invoiceDataNew,
            null
          );
        }
      },

      error: (error: HttpErrorResponse) => {
        this.toastService.error(
          error.error?.message ??
            'Error al obtener los datos necesarios para generar el PDF'
        );

        this.loadingDownload[invoiceData.id] = false;
      }
    });
  }

  getInvoiceData(invoice: any) {
    var templateGenerated = new InvoiceTemplateModel();
    templateGenerated.type = InvoiceType.NORMAL;
    templateGenerated.currency = invoice.currency;
    templateGenerated.client.name = (invoice.clientData.name) ? invoice.clientData.name : '';
    
    const nit = invoice.clientData?.nit || '';
    const cui = invoice.clientData?.cui || '';
    const extranjero = invoice.clientData?.extranjero === true || invoice.clientData?.extranjero === 1;

    if (!nit || extranjero || nit.toLowerCase().includes('cf')) {
        templateGenerated.client.nit = cui || nit;
    } else {
        templateGenerated.client.nit = nit;
    }


    templateGenerated.client.address = (invoice.clientData.address) ? invoice.clientData.address : '';
    templateGenerated.certifier.signature = (invoice.signature) ? invoice.signature : '';
    templateGenerated.certifier.date = (invoice.certificationDate) ? invoice.certificationDate : "";
    templateGenerated.certifier.nit = (invoice.certifierNIT) ? invoice.certifierNIT : "";
    templateGenerated.certifier.data = (invoice.certifier) ? invoice.certifier : "";
    templateGenerated.invoice.date = (invoice.date) ? this.convertToString(invoice.date) : "";
    templateGenerated.invoice.number = (invoice.number) ? invoice.number : "";
    templateGenerated.invoice.serial = (invoice.series) ? invoice.series : "";
    templateGenerated.seller.name = this.companyName;
    templateGenerated.seller.city = (invoice.warehouseData.city) ? invoice.warehouseData.city : "";

    const company = JSON.parse(this.authService.getCurrentCompany() || '{}');
    templateGenerated.seller.nit = invoice.warehouseData?.nit?.trim() || company?.companyNIT?.trim() || '';

    templateGenerated.seller.state = (invoice.warehouseData.state) ? invoice.warehouseData.state : '';
    templateGenerated.seller.street = (invoice.warehouseData.street) ? invoice.warehouseData.street : "";
    if (invoice.warehouse == 3282 || invoice.warehouse == 3569) {
			templateGenerated.setPhrase(new ScenerySAT(0, 0));
		}else{
      if (invoice.taxRegime !== null && invoice.taxRegime !== undefined) {
              var scenary = invoice.taxRegime - 1 >= 0 ? invoice.taxRegime - 1 : 1;
              templateGenerated.setPhrase(new ScenerySAT(0, scenary));
      }else{
        templateGenerated.setPhrase(new ScenerySAT(0, invoice.scenery));
      }
    }
    templateGenerated.total = invoice.totalCost + invoice.totalTaxes + (invoice.totalExtraTax ? invoice.totalExtraTax : 0);
    templateGenerated.totalSubsidy = (invoice.totalSubsidio) ? invoice.totalSubsidio : 0;

    templateGenerated.totalIVAExempt = 0;
    templateGenerated.totalIDPExempt = 0;
    templateGenerated.hasRegularExtraTax = false;

    const gasExtraTaxes: { [key: number]: number } = {
      3: 4.70, // Gasolina Superior
      4: 4.14, // Gasolina Regular
      6: 1.30  // Diesel
    };
    invoice.items.forEach(element => {
      templateGenerated.items.push(new InvoiceItemModel(element.quantity, element.price + element.taxes + (element.extraTaxAmount ? element.extraTaxAmount : 0), element.descriptionProduct));
      const extraTaxId = Number(element.extraTax);
      if (gasExtraTaxes[extraTaxId] !== undefined) {
				let iva = 0;
				let idp = 0;
				const quantity = Number(element.quantity || 0);
				const price = Number(element.price || 0);
				const totalPrice = price * quantity;
				templateGenerated.hasRegularExtraTax = true;
				idp = quantity * gasExtraTaxes[extraTaxId];
				iva = (totalPrice * 0.12);
				templateGenerated.totalIVAExempt += iva;
				templateGenerated.totalIDPExempt += idp;
			}
    });

    // invoice.items.forEach(element => {
    //   templateGenerated.items.push(new InvoiceItemModel(element.quantity, element.price + element.taxes + (element.extraTaxAmount ? element.extraTaxAmount : 0), element.descriptionProduct));
    // });

    // if(this.hasExtraTaxRegularConfig){
    //   templateGenerated.hasRegularExtraTax = invoice.items.some(
    //     (element: InvoiceItemModel) => element.extraTax === 4
    //   );
    // }  



    return templateGenerated;
  }



  filtering() {
    this.pagination.total = this.sales.filter((sale) => {
      if (
        Number(this.warehouseSelected) !== -1 &&
        Number(this.warehouseSelected) !== Number(sale.warehouse)
      ) {
        return false;
      }

      const documentSearch =
        `${sale.number ?? ''} ${sale.series ?? ''}`.toLowerCase();

      if (!documentSearch.includes(this.searchVendor.toLowerCase())) {
        return false;
      }

      if (sale.isNcre) {
        return this.ncreCheck;
      }

      if (!this.invoiceCheck && sale.invoice) {
        return false;
      }

      if (!this.receiptCheck && !sale.invoice) {
        return false;
      }

      if (!this.goodCheck && sale.transactionType !== 'Servicio') {
        return false;
      }

      if (!this.serviceCheck && sale.transactionType === 'Servicio') {
        return false;
      }

      return true;
    });

    this.calculateTotal();
    this.resetPagination();
  }

  private calculateTotal(): void {
    this.total = 0;

    this.pagination.total.forEach((document: any) => {
      let documentTotal: number;

      if (document.isNcre) {
        documentTotal = Number(document.total ?? 0);
      } else {
        documentTotal =
          Number(document.totalCost ?? 0) +
          Number(document.totalTaxes ?? 0) +
          Number(document.totalExtraTax ?? 0);
      }
      const exchangeRateValue = Number(document.exchangeRate ?? 1);
      const exchangeRate = exchangeRateValue > 1
        ? Number(document.exchange)
        : exchangeRateValue;

      if (exchangeRate > 0) {
        documentTotal *= exchangeRate;
      }

      this.total += documentTotal;
    });
  }

  convertToString(date: number) {
    if (!date) {
      return '';
    }
    var tempDate = new Date(date);
    return getStringDate(tempDate);
  }

  cancelNewFamily() {
    if (!this.alwaysCreating) {
      this.creating = false
    }
    this.resetNewFamily();
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  downloadInvoice(invoice: any) {
    if (this.loadingDownload[invoice.id]) {
      return;
    }
    this.loadingDownload[invoice.id] = true;
    this.createInvoicePDF(invoice);
  }

  oldDownload(invoice: any) {
    this.saleService.downloadPdf(invoice)
      .subscribe((data) => {
        // Crea un objeto Blob con los bytes del PDF
        const blob = new Blob([data], { type: 'application/pdf' });
        // Crea una URL de objeto para el Blob
        const url = window.URL.createObjectURL(blob);

        // Crea un enlace temporal para descargar el PDF
        const a = document.createElement('a');
        a.href = url;
        a.download = invoice.series + '-' + invoice.number + '.pdf';
        a.style.display = 'none';
        document.body.appendChild(a);
        // Inicia la descarga del PDF y luego elimina el enlace
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        this.loadingDownload[invoice.id] = false;
      }, (error) => {
        this.toastService.error("Error al obtener el pdf");
        this.loadingDownload[invoice.id] = false;
      });
  }

  searching() {
    this.pagination.total = this.sales.filter((sale) => {
      return sale.number.includes(this.searchVendor) || sale.series.toLowerCase().includes(this.searchVendor.toLowerCase())
    });
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  transform(product: any) {
    this.transforming = true;
    this.saleService.transformProductSale(this.currentCompany, product.clientInvoice, product.product, product['input'].data.id).subscribe({
      next: (response: ResponseObject) => {
        this.transforming = false;
        this.resetTransform(product['input']);
        this.getSalesByIntervalDate();
        this.toastService.success("Se transformó correctamente el producto");
      },
      error: (error: HttpErrorResponse) => {
        this.transforming = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  writeProduct(value: any, input: InputAutocompleteModel) {
    var inputValue = value.target.value;
    clearTimeout(this.timeout);
    input.class = "typing";
    this.timeout = setTimeout(() => {
      input.filterElements = this.products.filter((product) => {
        return product.name.toLowerCase().includes(inputValue.toLowerCase())
          || (product.code + "").toLowerCase() == inputValue.toLowerCase() || (product.barCode && product.barCode == inputValue.toLowerCase())
      });
      input.verified = false;
      input.data = null;
      if (input.filterElements.length == 0) {
        input.class = "fa-xmark";
      } else {
        input.class = "fa-list";
      }
    }, 400);
  }

  resetTransform(input: InputAutocompleteModel) {
    input.class = "fa-list";
    input.filterElements = this.products;
    input.value = "";
    input.required = true;
    input.verified = false;
    this.productToTransform = null;
  }

  selectProduct(product, input: InputAutocompleteModel) {
    input.verified = true;
    input.data = product;
    input.class = "fa fa-circle-check";
    input.value = product.code + " - " + product.name;
  }

  getMoreProducts() {
    this.productService.getProducts("").subscribe({
      next: (response: ResponseObject) => {
        this.products = response.data.filter((product) => {
          return !product.code.includes("XML")
        });
        this.filterProducts = this.products;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  private convertNcreToSale(ncre: any): any {
    const warehouse = this.warehouses.find(
      warehouse => Number(warehouse.id) === Number(ncre.warehouseId)
    );

    return {
      /*
      * Se agrega un prefijo para evitar que el ID de la NCRE
      * pueda coincidir con el ID de una factura.
      */
      id: `NCRE-${ncre.id}`,

      // ID real del ERPDocument, por si después se necesita.
      erpDocumentId: ncre.id,

      documentId: ncre.documentId,
      series: ncre.series ?? '',
      number: ncre.number ?? '',

      /*
      * En ERPDocument:
      * date = fecha contable
      * documentDate = fecha propia del documento
      */
      accountingDate: ncre.date,
      date: ncre.documentDate ?? ncre.date,
      creationDate: ncre.creationDate,

      warehouse: ncre.warehouseId,
      warehouseData: warehouse ?? {
        id: ncre.warehouseId,
        name: 'Sin bodega'
      },

      nit: ncre.nit ?? '',
      clientData: {
        id: ncre.vendorId,
        nit: ncre.nit ?? '',
        name: ncre.name ?? ''
      },

      /*
      * Adaptación de los totales de ERPDocument.
      */
      totalCost: Number(ncre.netPrice ?? 0),
      totalTaxes: Number(ncre.taxes ?? 0),
      totalExtraTax: 0,

      /*
      * Guarda también el total original para mostrarlo directamente.
      */
      total: Number(
        ncre.total ??
        ncre.documentTotal ??
        0
      ),

      currency: Number(ncre.currency ?? 0),
      exchangeRate: Number(ncre.exchangeRate ?? 1),

      transactionType: ncre.transaction ?? '',
      description: ncre.description ?? '',

      cancelled: ncre.cancelled ?? false,
      cancelledDescription: ncre.cancelledDescription ?? '',

      // Propiedades especiales para identificarla.
      isNcre: true,
      documentTypeName: 'Nota de crédito',

      // Una NCRE no tendrá tipo de pago.
      methodPay: null,

      /*
      * No se utiliza como factura/recibo porque la NCRE tendrá
      * su propio filtro.
      */
      invoice: false
    };
  }

  private filterSalesByUserPermissions(sales: any[]): any[] {
    let filteredSales = [...sales];

    if (this.userId != 3186 && this.userId != 11174 && this.userId != 3191 
      && !(this.userEmail && this.userEmail.includes('@impulsocomercial.gt')) ) {

      if (!this.seeingAll && !this.filteredByWarehouse) {
        filteredSales = filteredSales.filter(sale =>
          sale.user == this.userId
        );
      }
    }

    if (this.filteredByWarehouse && !this.seeingAll) {
      filteredSales = filteredSales.filter(sale =>
        this.allowedWarehouses[sale.warehouse]
      );
    }

    return filteredSales;
  }

  private filterNcresByWarehousePermission(ncres: any[]): any[] {
    if (this.filteredByWarehouse && !this.seeingAll) {
      return ncres.filter(ncre =>
        this.allowedWarehouses[ncre.warehouse]
      );
    }

    return ncres;
  }

  getPaymentMethods(methodPay: string): string[] {
    if (!methodPay) {
      return [];
    }

    return methodPay
      .split(',')
      .map(method => method.trim())
      .filter(method => method.length > 0);
  }

  /*
  getPurchasesByIntervalDate() {
    this.searchVendor = "";
    this.purchaseService.getPurchasesByIntervalDate(getLongDate(this.startDate), getLongDate(this.endDate)).subscribe(
      {
        next: (response: ResponseObject) => {
          this.purchases = response.data;
          this.total = 0;
          this.purchases.forEach((s) => {
            this.total += (s.totalCost + s.totalTaxes + s.extraTax);
            this.getTotalDetail(s);
          })
          this.purchases = this.purchases.sort((a, b) => {
            if (b.date !== a.date) {
              return b.date - a.date;
            } else {
              return b.id - a.id;
            }
          });
          if (this.isAscendent == 1) {
            this.purchases.reverse();
          }
          this.filterCheck();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al obtener las facturas");
        }
      }
    );*/

}
